module.exports = __webpack_public_path__ + "static/media/ecofriendly.6e6b000d.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/categories/ecofriendly.svg
 ** module id = 447
 ** module chunks = 0
 **/